import React from 'react';
import { Button, Modal, Stack, Form, Row, Col } from 'react-bootstrap';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useUpdateUserDetailsMutation } from 'services';
import toast from 'react-hot-toast';
import useUserStore from 'store/user';
import useTranslate from 'hooks/useTranslate';
import useCommonStore from 'store/common';

const EditAboutUs: React.FC<any> = () => {
	const { profileData }: any = useUserStore((state) => state);
	const { modalConfig = {} }: any = useCommonStore((state) => state);
	const { mutateAsync: updateProfile } = useUpdateUserDetailsMutation();
	const { translate } = useTranslate();

	const formik: any = useFormik({
		initialValues: {
			about: profileData?.about || '',
			saveType: 'aboutUs',
		},
		enableReinitialize: true,
		validationSchema: Yup.object().shape({
			about: Yup.string()
				.required(translate('Validation.required', { field: translate('Validation.about') }))
				.trim(),
		}),
		onSubmit: (values: any) => {
			updateProfile({ ...values, about: values?.about.trim() })
				.then((res: any) => {
					if (res?.success) {
						toast.success(res?.message);
					}
				})
				.finally(() => modalConfig?.onClose());
		},
	});

	return (
		<Modal.Body>
			<Button
				className="close-btn rounded-circle border-0 fw-bold position-absolute"
				onClick={() => modalConfig?.onClose()}
			>
				<i className="ri-close-line"></i>
			</Button>
			<Form className="edit-form" onSubmit={formik.handleSubmit}>
				<Stack className="gap-4">
					<h4 className="fw-bold mb-0">{translate('Profile.editAboutDetail')}</h4>
					<Row>
						<Col>
							<Form.Group className="mb-4 position-relative">
								<Form.Label className="lh-1">{translate('Profile.editAbout')}</Form.Label>
								<Form.Control
									name="about"
									as="textarea"
									rows={4}
									placeholder={translate('PlaceHolder.writeHere')}
									onChange={(e) => {
										let inputValue = e.target.value;

										// Remove leading spaces if present
										inputValue = inputValue.replace(/^\s+/, '');

										// Allow only one space between words
										// inputValue = inputValue.replace(/\s{2,}/g, ' ');
										formik.setFieldValue('about', inputValue);
									}}
									onBlur={formik.handleBlur}
									value={formik.values.about}
									autoComplete="off"
								/>
								{formik?.errors?.about && (
									<span className="text-danger f-error">{formik.errors.about}</span>
								)}
							</Form.Group>
						</Col>
					</Row>
					<div className="edit-modal-actions d-flex gap-4">
						<Button className="filled-btn rounded-pill" type="submit">
							{translate('Common.save')}
						</Button>
					</div>
				</Stack>
			</Form>
		</Modal.Body>
	);
};

export default EditAboutUs;
